import { useLocalStorageState } from './useLocalStorageState';
import { addBusinessDays, isPast } from 'date-fns';
/** This hook is useful for situations such as "I only want this feedback form to show up once every 14 days" */
export const useShowEveryXBusinessDays = (
/** The storage key to use */
storageKey, 
/** The number of business days between requests */
businessDaysBetweenRequests) => {
    const [lastDate, setLastDate] = useLocalStorageState(storageKey, undefined);
    const nextDate = lastDate
        ? addBusinessDays(lastDate, businessDaysBetweenRequests).getTime()
        : undefined;
    const show = !nextDate || isPast(nextDate);
    return {
        show,
        nextDate,
        lastDate,
        // @ts-ignore // this was designed to mock a setstate
        setLastDate,
    };
};
